export default function getResource(label, vars = []) {
    const resources = {
        myBasketLabel: 'Mon panier',
        yourBasketLabel: 'Vos paniers'
    };

    return resources[label];
}
